"use client";
import React from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import "../../assets/scss/components/_inclusions.scss";

const InclusionsSection = ({ rooms }) => {

  const inclusionsList = [
    ...new Set(rooms.flatMap(room => room.inclusions || []))
  ];

  const hasInclusion = (room, item) => {
    return room.inclusions?.some(
      inc => inc.trim().toLowerCase() === item.trim().toLowerCase()
    );
  };

  return (
    <section className="room-inclusions">
      <h2>Room Categories & Their Exclusive Features</h2>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Facilities / Services</th>
              {rooms.map(room => (
                <th key={room.slug}>{room.slug}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {inclusionsList.map((item, index) => (
              <tr key={index}>
                <td>{item}</td>

                {rooms.map(room => (
                  <td key={room.slug}>
                    {hasInclusion(room, item) ? (
                      <FaCheck className="yes" />
                    ) : (
                      <FaTimes className="no" />
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default InclusionsSection;